export default [
  {value: 1, name: 'pc'},
  {value: 2, name: 'app'}
]